module.exports = __webpack_public_path__ + "static/img/UBC老师_Holly.7101673.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC老师_Holly.png
// module id = tlde
// module chunks = 0